<script>
export default {
    name: "ContactForm"
}
</script>

<template>
    <div id="contacts" class="contacts container">
        <div class="contacts_block ">
            <div class="text">
                <div class="title">
                    {{ $gettext('Бажаєте отримати детальну інформацію?') }}
                </div>
                <div class="desc">
                    {{ $gettext('Залиште запит і отримайте персональне рішення вже сьогодні') }}
                </div>
            </div>
            <div class="inputs">
                <div class="inputs-row">
                    <div class="inputs--item">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.9997 25.6668C12.3858 25.6668 10.8691 25.3606 9.44968 24.7481C8.03023 24.1356 6.79551 23.3043 5.74551 22.2543C4.69551 21.2043 3.86426 19.9696 3.25176 18.5502C2.63926 17.1307 2.33301 15.6141 2.33301 14.0002C2.33301 12.3863 2.63926 10.8696 3.25176 9.45016C3.86426 8.03072 4.69551 6.796 5.74551 5.746C6.79551 4.696 8.03023 3.86475 9.44968 3.25225C10.8691 2.63975 12.3858 2.3335 13.9997 2.3335C15.6136 2.3335 17.1302 2.63975 18.5497 3.25225C19.9691 3.86475 21.2038 4.696 22.2538 5.746C23.3038 6.796 24.1351 8.03072 24.7476 9.45016C25.3601 10.8696 25.6663 12.3863 25.6663 14.0002V15.546C25.6663 16.6349 25.2823 17.5536 24.5143 18.3022C23.7462 19.0509 22.808 19.4252 21.6997 19.4252C20.9997 19.4252 20.3386 19.255 19.7163 18.9147C19.0941 18.5745 18.6177 18.0932 18.2872 17.471C17.7816 18.1321 17.1497 18.6231 16.3913 18.9439C15.633 19.2647 14.8358 19.4252 13.9997 19.4252C12.483 19.4252 11.1948 18.9002 10.1351 17.8502C9.07537 16.8002 8.54551 15.5168 8.54551 14.0002C8.54551 12.4835 9.07537 11.1904 10.1351 10.121C11.1948 9.05155 12.483 8.51683 13.9997 8.51683C15.5163 8.51683 16.8045 9.05155 17.8643 10.121C18.924 11.1904 19.4538 12.4835 19.4538 14.0002V15.546C19.4538 16.1488 19.6726 16.6543 20.1101 17.0627C20.5476 17.471 21.0775 17.6752 21.6997 17.6752C22.3025 17.6752 22.8226 17.471 23.2601 17.0627C23.6976 16.6543 23.9163 16.1488 23.9163 15.546V14.0002C23.9163 11.2391 22.9538 8.896 21.0288 6.971C19.1038 5.046 16.7608 4.0835 13.9997 4.0835C11.2386 4.0835 8.89551 5.046 6.97051 6.971C5.04551 8.896 4.08301 11.2391 4.08301 14.0002C4.08301 16.7613 5.04551 19.1043 6.97051 21.0293C8.89551 22.9543 11.2386 23.9168 13.9997 23.9168H20.2413V25.6668H13.9997ZM13.9997 17.6752C15.0302 17.6752 15.9052 17.3203 16.6247 16.6106C17.3441 15.9009 17.7038 15.0307 17.7038 14.0002C17.7038 12.9502 17.3441 12.0654 16.6247 11.346C15.9052 10.6266 15.0302 10.2668 13.9997 10.2668C12.9691 10.2668 12.0941 10.6266 11.3747 11.346C10.6552 12.0654 10.2955 12.9502 10.2955 14.0002C10.2955 15.0307 10.6552 15.9009 11.3747 16.6106C12.0941 17.3203 12.9691 17.6752 13.9997 17.6752Z"
                                  fill="#015AB4"/>
                        </svg>
                        <input type="text" placeholder="E-mail*">
                    </div>
                    <div class="inputs--item">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.1875 24.5C20.8153 24.5 18.4576 23.9167 16.1146 22.75C13.7715 21.5833 11.6667 20.0667 9.8 18.2C7.93333 16.3333 6.41667 14.2285 5.25 11.8854C4.08333 9.54236 3.5 7.18472 3.5 4.8125C3.5 4.43749 3.625 4.12499 3.875 3.875C4.12499 3.625 4.43749 3.5 4.8125 3.5H8.89583C9.16049 3.5 9.3968 3.59236 9.60476 3.77708C9.8127 3.96181 9.94583 4.20972 10.0042 4.52083L10.7917 8.19583C10.8306 8.46806 10.8257 8.71597 10.7771 8.93958C10.7285 9.16319 10.6264 9.35278 10.4708 9.50833L7.55417 12.4542C8.64306 14.2625 9.86319 15.8375 11.2146 17.1792C12.566 18.5208 14.0972 19.6583 15.8083 20.5917L18.5792 17.7333C18.7736 17.5194 18.9972 17.3687 19.25 17.2812C19.5028 17.1938 19.7556 17.1792 20.0083 17.2375L23.4792 17.9958C23.7769 18.0615 24.0215 18.2091 24.2129 18.4388C24.4043 18.6685 24.5 18.9389 24.5 19.25V23.1875C24.5 23.5625 24.375 23.875 24.125 24.125C23.875 24.375 23.5625 24.5 23.1875 24.5ZM6.67917 10.85L9.04167 8.45833L8.37083 5.25H5.25C5.25 6.00833 5.36667 6.83958 5.6 7.74375C5.83333 8.64792 6.19306 9.68333 6.67917 10.85ZM17.4417 21.4375C18.2389 21.8069 19.1042 22.1083 20.0375 22.3417C20.9708 22.575 21.875 22.7111 22.75 22.75V19.6292L19.7458 19.0167L17.4417 21.4375Z"
                                  fill="#015AB4"/>
                        </svg>
                        <input type="text" :placeholder="$gettext('Телефон')">
                    </div>
                </div>
                <textarea :placeholder="$gettext('Ваше повідомлення')"/>
            </div>
            <div class="button">
                {{ $gettext('Надіслати запит') }}
            </div>
            <img
                    class="contacts-img"
                    srcset="../../assets/images/png/contactsImg2x.png 2x, ../../assets/images/png/contactsImg3x.png 3x, ../../assets/images/png/contactsImg4x.png 4x"
                    src="../../assets/images/png/contactsImg3x.png"
                    alt=""
            />
            <img
                    class="contacts-img_mob"
                    srcset="../../assets/images/png/contactsImgMob2x.png 2x, ../../assets/images/png/contactsImgMob3x.png 3x, ../../assets/images/png/contactsImgMob4x.png 4x"
                    src="../../assets/images/png/contactsImgMob3x.png"
                    alt=""
            />
        </div>
    </div>
</template>

<style lang="scss">
.contacts {
  box-sizing: border-box;

  @media (max-width: 1079px) {
    padding: 0 16px;
  }

  &_block {
    border-radius: 24px;
    background: #015AB4;
    padding: 36px 0 40px 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    overflow: hidden;

    @media (max-width: 1079px) {
      padding: 208px 24px 24px 24px;
    }

    .text {
      max-width: 663px;

      .title {
        color: #FFF;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 46px;
        letter-spacing: -0.8px;
        margin-bottom: 20px;

        @media (max-width: 1079px) {
          font-size: 24px;
          line-height: 30px;
          letter-spacing: -0.48px;
          text-align: center;
          margin-bottom: 16px;
        }
      }

      .desc {
        color: rgba(255, 255, 255, 0.64);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.32px;
        margin-bottom: 32px;

        @media (max-width: 1079px) {
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.28px;
          text-align: center;
          margin-bottom: 28px;
        }
      }
    }

    .inputs {
      margin-bottom: 24px;
      display: flex;
      flex-direction: column;
      gap: 24px;

      @media (max-width: 1079px) {
        width: 100%;
        gap: 8px;
        margin-bottom: 16px;
      }

      &--item {
        position: relative;

        svg {
          position: absolute;
          top: 12px;
          left: 12px;

          @media (max-width: 1079px) {
            left: 10px;
            top: 10px;
            width: 24px;
            height: 24px;
          }
        }
      }

      &-row {
        display: flex;
        flex-direction: row;
        gap: 24px;

        @media (max-width: 1079px) {
          flex-direction: column;
          gap: 8px;
        }

        input {
          width: 300px;
          border-radius: 8px;
          background: #FFF;
          padding: 14px 20px 14px 48px;
          box-sizing: border-box;
          outline: none;
          border: none;
          color: black;
          font-family: 'Golos Text', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: -0.32px;

          &::placeholder {
            color: #8281B1;
            opacity: 1;
          }

          @media (max-width: 1079px) {
            padding: 12px 16px 12px 42px;
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: -0.28px;
          }
        }
      }

      textarea {
        border-radius: 8px;
        background: #FFF;
        padding: 14px 20px;
        box-sizing: border-box;
        outline: none;
        border: none;
        color: #8281B1;
        font-family: 'Golos Text', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.32px;
        height: 140px;
        resize: none;

        &::placeholder {
          color: #8281B1;
          opacity: 1;
        }

        @media (max-width: 1079px) {
          padding: 12px 16px;
          width: 100%;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.28px;
        }
      }

    }

    .button {
      border-radius: 8px;
      background: #FF7438;
      padding: 16px 32px;
      box-sizing: border-box;
      color: #FFF;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
      transition: all .3s ease-in-out;

      &:hover {
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%), var(--orange, #FF6B2C);
      }

      @media (max-width: 1079px) {
        width: 100%;
      }
    }

  }

  &-img {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    @media (max-width: 1079px) {
      display: none;
    }
  }

  &-img_mob {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    z-index: 0;
    @media (max-width: 1079px) {
      display: block;
    }
  }
}
</style>
